import { message, Drawer, Descriptions, Button } from 'antd'
import React, { useCallback, useState } from 'react'
import { createUseStyles } from 'react-jss'
import { useHistory, useParams } from 'react-router-dom'
import SplitPane from 'react-split-pane'
import api from '../../api'
import { PageHeader } from '../Common'
import PDFPreview from '../Common/PDFPreview'
import { useAsync } from '../../hooks'
import Loading from '../Loading'
import TransmissionSidebar from '../Common/TransmissionSidebar'
import AlertForm from './AlertForm'

const useStyles = createUseStyles({
  app: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flex: '1 1 auto',
  },
  pdfBox: {
    maxWidth: 'calc(100% - 456px)',
    flexGrow: '1',
    minWidth: '100%',
    position: 'relative',
    height: 'calc(100vh - 96px - 68px)',
    overflowY: 'scroll',
    overflowX: 'hidden',
    '& canvas': {
      maxWidth: '100%',
    },
  },
  formBox: {
    position: 'relative',
    overflowY: 'scroll',
    height: 'calc(100vh - 96px - 68px)',
    padding: '0 16px',
    '& > form': {
      marginTop: '-16px',
    },
  },
})

export default function Edit() {
  const { id } = useParams()
  const classes = useStyles()
  const history = useHistory()
  const getAlert = useCallback(
    () => api.alerts.get(id, { includeForm: true }),
    [id],
  )
  const { pending, value: alert } = useAsync(getAlert)
  const [visiblePatient, setVisiblePatient] = useState(false)

  const onSubmit = useCallback(
    async values => {
      try {
        await api.alerts.update(id, values)
        message.success('Alert successfully updated')
        history.goBack()
      } catch (e) {
        message.error('Oops, we had a problem. Please try submitting again')
      }
    },
    [history, id],
  )

  if (pending) return <Loading large />

  return (
    <div className={classes.app}>
      <PageHeader
        title="Edit Alert"
        onBack={history.goBack}
        extra={<Button onClick={() => setVisiblePatient(true)}>Patient</Button>}
      />
      <SplitPane split="vertical">
        <div initialSize="65%" minSize="10%" className={classes.pdfBox}>
          <PDFPreview path={alert.rawFilePath} perPage={10} />
        </div>
        <div className={classes.formBox}>
          <AlertForm
            form={{ ...alert.form, critical: alert.critical }}
            onSubmit={onSubmit}
          />
        </div>
      </SplitPane>
      <Drawer
        title="Patient Information"
        width={360}
        placement="right"
        onClose={() => setVisiblePatient(false)}
        visible={visiblePatient}
      >
        <Descriptions column={1} size="small" layout="vertical">
          <Descriptions.Item label="Device Type">
            {alert.device.deviceModel.deviceType.name}
          </Descriptions.Item>
          <Descriptions.Item label="Device Serial Number">
            {alert.device.serialNumber}
          </Descriptions.Item>
        </Descriptions>
        <TransmissionSidebar
          patient={alert.patient}
          practiceId={alert.patient.practiceId}
        />
      </Drawer>
    </div>
  )
}
